var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("sc-form", {
        ref: "form",
        attrs: {
          form: _vm.form,
          rules: _vm.rules,
          hasStyle: false,
          buttonsStyle: false
        },
        on: { submit: _vm.onGetReconAnalytics },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              var isValid = ref.isValid
              return [
                _c("div", { staticClass: "columns is-multiline" }, [
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Centros de Distribuição",
                            prop: "warehouses"
                          }
                        },
                        [
                          _c("sc-warehouse-dropdown", {
                            attrs: { "list-user": "", dropdown: "" },
                            on: {
                              selectAll: function(values) {
                                return (fields.warehouses = values)
                              },
                              clearFilter: function() {
                                return (fields.warehouses = [])
                              }
                            },
                            model: {
                              value: fields.warehouses,
                              callback: function($$v) {
                                _vm.$set(fields, "warehouses", $$v)
                              },
                              expression: "fields.warehouses"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Transportadora",
                            prop: "logisticProviders"
                          }
                        },
                        [
                          _c("sc-logistic-provider-dropdown", {
                            attrs: { dropdown: "" },
                            on: {
                              selectAll: function(values) {
                                return (fields.logisticProviders = values)
                              },
                              clearFilter: function() {
                                return (fields.logisticProviders = [])
                              }
                            },
                            model: {
                              value: fields.logisticProviders,
                              callback: function($$v) {
                                _vm.$set(fields, "logisticProviders", $$v)
                              },
                              expression: "fields.logisticProviders"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "sc-field",
                        {
                          attrs: {
                            label: "Data de despacho",
                            prop: "dateRange"
                          }
                        },
                        [
                          _c(
                            "sc-select",
                            {
                              attrs: { expanded: "" },
                              model: {
                                value: fields.dateRange,
                                callback: function($$v) {
                                  _vm.$set(fields, "dateRange", $$v)
                                },
                                expression: "fields.dateRange"
                              }
                            },
                            _vm._l(_vm.dateList, function(item, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: item.value } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.label) +
                                      "\n              "
                                  )
                                ]
                              )
                            })
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "columns sc-form__footer sc-analytics-filters__footer"
                  },
                  [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "div",
                        { staticClass: "buttons is-right" },
                        [
                          _c("sc-button", {
                            attrs: {
                              loading: _vm.loading,
                              type: "submit",
                              theme: "primary",
                              text: "Consultar"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c3852e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c3852e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-filters/ScAnalyticsFilters.vue
// module id = null
// module chunks = 